<template lang="html">
  <div class="auth-form-transparent text-left p-3">
    <div class="brand-logo">
      <img src="/img/logo.png" alt="logo"> TradingApp
    </div>
    <h4>Welcome back!</h4>
    <h6 class="font-weight-light">Пожалуйста, перейдите по ссылке в вашем электронном письме, чтобы сбросить пароль.</h6>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      errorText: null
    }
  },
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordStep2.vue